import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import { WOW } from 'wowjs';
import '../css/global.css';
import '../css/Tenders.css';

const Tenders = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        const wow = new WOW({
            live: false
        });
        wow.init();
    }, []);

    return (
        <div className="tenders-page">
            <Header />
            
            <section className="contentwrapper clearfix">
                <div className="content member-page clearfix">
                    <div className="breadcrumbs">
                        <a href="/">Home</a> &gt; <span>Tenders</span>
                    </div>
                    
                    <h1 data-aos="fade-right" style={{ color: '#002079' }}>Tenders</h1>

                    <div className="tenders-grid">
                        <div className="tender-item" data-aos="fade-up" data-aos-delay="100">
                            <a href="/wp-content/uploads/2017/10/english-advertisement.pdf" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/wp-content/uploads/2017/10/2.png" 
                                    alt="English Advertisement" 
                                    className="attachment-full" 
                                />
                            </a>
                        </div>
                        
                        <div className="tender-item" data-aos="fade-up" data-aos-delay="200">
                            <a href="/wp-content/uploads/2017/10/sinhala-advertisement.pdf" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="/wp-content/uploads/2017/10/1.jpg" 
                                    alt="Sinhala Advertisement" 
                                    className="attachment-full" 
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
};

export default Tenders;
